const Logo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="420"
    height="80"
    version="1.1"
    viewBox="0 0 420 80"
  >
    <defs>
      <linearGradient
        id="b"
        x1="65"
        x2="485"
        y1="235"
        y2="235"
        gradientTransform="matrix(7.5 0 0 -7.5 -487.5 2063.22)"
        gradientUnits="userSpaceOnUse"
        spreadMethod="pad"
      >
        <stop offset="0" stopColor="#00968f" stopOpacity="1"></stop>
        <stop offset="1" stopColor="#00fff4" stopOpacity="1"></stop>
      </linearGradient>
      <linearGradient
        id="d"
        x1="65"
        x2="485"
        y1="235"
        y2="235"
        gradientTransform="matrix(7.5 0 0 -7.5 -487.5 2063.22)"
        gradientUnits="userSpaceOnUse"
        spreadMethod="pad"
      >
        <stop offset="0" stopColor="#00968f" stopOpacity="1"></stop>
        <stop offset="1" stopColor="#00fff4" stopOpacity="1"></stop>
      </linearGradient>
      <linearGradient
        id="f"
        x1="65"
        x2="485"
        y1="235"
        y2="235"
        gradientTransform="matrix(7.5 0 0 -7.5 -487.5 2063.22)"
        gradientUnits="userSpaceOnUse"
        spreadMethod="pad"
      >
        <stop offset="0" stopColor="#00968f" stopOpacity="1"></stop>
        <stop offset="1" stopColor="#00fff4" stopOpacity="1"></stop>
      </linearGradient>
      <linearGradient
        id="h"
        x1="65"
        x2="485"
        y1="235"
        y2="235"
        gradientTransform="matrix(7.5 0 0 -7.5 -487.5 2063.22)"
        gradientUnits="userSpaceOnUse"
        spreadMethod="pad"
      >
        <stop offset="0" stopColor="#00968f" stopOpacity="1"></stop>
        <stop offset="1" stopColor="#00fff4" stopOpacity="1"></stop>
      </linearGradient>
      <linearGradient
        id="j"
        x1="65"
        x2="485"
        y1="235"
        y2="235"
        gradientTransform="matrix(7.5 0 0 -7.5 -487.5 2063.22)"
        gradientUnits="userSpaceOnUse"
        spreadMethod="pad"
      >
        <stop offset="0" stopColor="#00968f" stopOpacity="1"></stop>
        <stop offset="1" stopColor="#00fff4" stopOpacity="1"></stop>
      </linearGradient>
      <linearGradient
        id="l"
        x1="65"
        x2="485"
        y1="235"
        y2="235"
        gradientTransform="matrix(7.5 0 0 -7.5 -487.5 2063.22)"
        gradientUnits="userSpaceOnUse"
        spreadMethod="pad"
      >
        <stop offset="0" stopColor="#00968f" stopOpacity="1"></stop>
        <stop offset="1" stopColor="#00fff4" stopOpacity="1"></stop>
      </linearGradient>
      <clipPath id="a" clipPathUnits="userSpaceOnUse">
        <path d="M1369.77 578.672h164.84c13.98-71.402 27.46-129.332 40.47-173.832 13.98-47.93 33.47-100.621 58.44-158.078 46.44 97.929 79.41 208.547 98.9 331.91h164.85c-16.49-86.91-42.97-179.801-79.46-278.711-37.46-102.383-79.65-194.801-126.6-277.23h-115.39c-109.88 204.3-178.55 389.609-206.05 555.941"></path>
      </clipPath>
      <clipPath id="c" clipPathUnits="userSpaceOnUse">
        <path d="M2083.83 22.73h-141.641V454.3h141.641Zm-147.62 555.942h153.59c-5-28.442-14.49-52.192-28.47-71.172-13.99-18.98-29.96-28.48-47.93-28.48-18.01 0-34.1 9.5-48.36 28.48-14.22 18.98-23.83 42.73-28.83 71.172"></path>
      </clipPath>
      <clipPath id="e" clipPathUnits="userSpaceOnUse">
        <path d="M2467.42 454.301V341.91h-125.86c-20 0-29.96-5.23-29.96-15.738 0-7.973 8.24-17.692 24.73-29.223 1.99-.969 15.97-9.219 41.95-24.719 30.98-17.968 53.2-35.429 66.68-52.429 18.48-22.961 27.7-50.973 27.7-83.903 0-28.476-9.73-52.968-29.22-73.437-24.96-26.48-62.42-39.73-112.39-39.73h-179.8v112.39h146.09c18.99 0 28.48 7.258 28.48 21.758 0 11.48-14.73 26.711-44.22 45.699-51.44 33.442-83.4 56.442-95.9 68.902-19.96 20-29.96 44.969-29.96 74.93 0 71.949 43.71 107.891 131.14 107.891z"></path>
      </clipPath>
      <clipPath id="g" clipPathUnits="userSpaceOnUse">
        <path d="M2681.72 22.73h-141.598V454.3h141.598ZM2534.1 578.673h153.6c-4.97-28.442-14.46-52.192-28.44-71.172-14.03-18.98-30-28.48-47.97-28.48s-34.1 9.5-48.32 28.48c-14.26 18.98-23.87 42.73-28.87 71.172"></path>
      </clipPath>
      <clipPath id="i" clipPathUnits="userSpaceOnUse">
        <path d="M2726.68 578.672H3150V454.301h-132.62V22.731H2859.3V454.3h-132.62z"></path>
      </clipPath>
      <clipPath id="k" clipPathUnits="userSpaceOnUse">
        <path
          d="M501.91 1.45h614.81L759.41 600 0 1.45h215.391l507.308 399.8 158.903-266.41H673.199Z"
          clipRule="evenodd"
        ></path>
      </clipPath>
    </defs>
    <g transform="matrix(1.33333 0 0 -1.33333 0 80)">
      <g transform="scale(.1)">
        <g>
          <g clipPath="url(#a)">
            <path
              fill="url(#b)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1369.77 578.672h164.84c13.98-71.402 27.46-129.332 40.47-173.832 13.98-47.93 33.47-100.621 58.44-158.078 46.44 97.929 79.41 208.547 98.9 331.91h164.85c-16.49-86.91-42.97-179.801-79.46-278.711-37.46-102.383-79.65-194.801-126.6-277.23h-115.39c-109.88 204.3-178.55 389.609-206.05 555.941"
            ></path>
          </g>
        </g>
        <g>
          <g clipPath="url(#c)">
            <path
              fill="url(#d)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2083.83 22.73h-141.641V454.3h141.641Zm-147.62 555.942h153.59c-5-28.442-14.49-52.192-28.47-71.172-13.99-18.98-29.96-28.48-47.93-28.48-18.01 0-34.1 9.5-48.36 28.48-14.22 18.98-23.83 42.73-28.83 71.172"
            ></path>
          </g>
        </g>
        <g>
          <g clipPath="url(#e)">
            <path
              fill="url(#f)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2467.42 454.301V341.91h-125.86c-20 0-29.96-5.23-29.96-15.738 0-7.973 8.24-17.692 24.73-29.223 1.99-.969 15.97-9.219 41.95-24.719 30.98-17.968 53.2-35.429 66.68-52.429 18.48-22.961 27.7-50.973 27.7-83.903 0-28.476-9.73-52.968-29.22-73.437-24.96-26.48-62.42-39.73-112.39-39.73h-179.8v112.39h146.09c18.99 0 28.48 7.258 28.48 21.758 0 11.48-14.73 26.711-44.22 45.699-51.44 33.442-83.4 56.442-95.9 68.902-19.96 20-29.96 44.969-29.96 74.93 0 71.949 43.71 107.891 131.14 107.891z"
            ></path>
          </g>
        </g>
        <g>
          <g clipPath="url(#g)">
            <path
              fill="url(#h)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2681.72 22.73h-141.598V454.3h141.598ZM2534.1 578.673h153.6c-4.97-28.442-14.46-52.192-28.44-71.172-14.03-18.98-30-28.48-47.97-28.48s-34.1 9.5-48.32 28.48c-14.26 18.98-23.87 42.73-28.87 71.172"
            ></path>
          </g>
        </g>
        <g>
          <g clipPath="url(#i)">
            <path
              fill="url(#j)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M2726.68 578.672H3150V454.301h-132.62V22.731H2859.3V454.3h-132.62z"
            ></path>
          </g>
        </g>
        <g>
          <g clipPath="url(#k)">
            <path
              fill="url(#l)"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M501.91 1.45h614.81L759.41 600 0 1.45h215.391l507.308 399.8 158.903-266.41H673.199Z"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Logo;
